import { ReactNode, useState } from 'react';

import ReactPlayer, { ReactPlayerProps } from 'react-player';

import { PlayIconWrapper, VideoWrapper, Overlay } from './styled';

type Props = ReactPlayerProps & {
  FallbackComponent?: ReactNode;
  PlayIcon?: ReactNode;
  tour?: boolean;
};

const VideoPlayer = ({
  url,
  FallbackComponent,
  PlayIcon,
  tour,
  ...others
}: Props) => {
  const [videoError, setVideoError] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const handlePlayIconClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent the click from affecting the video click handler
    setIsVideoPlaying(false);
  };

  const handleVideoClick = () => {
    setIsVideoPlaying((prev) => !prev); // Toggle play/pause
  };

  return (
    <VideoWrapper onClick={handleVideoClick}>
      {url && !videoError ? (
        <>
          <ReactPlayer
            url={url}
            width='100%'
            height='100%'
            controls
            playing={isVideoPlaying}
            onError={() => setVideoError(true)}
            onPause={() => setIsVideoPlaying(false)}
            onPlay={() => setIsVideoPlaying(true)}
            onClickPreview={() => setIsVideoPlaying(true)}
            {...others}
          />
          {tour ? <Overlay onClick={handlePlayIconClick} /> : null}

          {!isVideoPlaying && <PlayIconWrapper>{PlayIcon}</PlayIconWrapper>}
        </>
      ) : (
        FallbackComponent
      )}
    </VideoWrapper>
  );
};

export default VideoPlayer;
